export default util
export const {
  TextDecoder,
  TextEncoder,
  callbackify,
  debug,
  debuglog,
  deprecate,
  error,
  format,
  getSystemErrorName,
  inherits,
  inspect,
  isArray,
  isBoolean,
  isBuffer,
  isDate,
  isError,
  isFunction,
  isNull,
  isNullOrUndefined,
  isNumber,
  isObject,
  isPrimitive,
  isRegExp,
  isString,
  isSymbol,
  isUndefined,
  log,
  print,
  promisify,
  puts,
} = util